import { render } from "./index.vue?vue&type=template&id=90e343c0"
const script = {}

import exportComponent from "/home/deck/Documents/Programmieren/uqloud site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__